export default __webpack_public_path__ + "static/Harmonized-c2f5b65a858c3c0454dfeb07da22e44f.mp4";